export default __webpack_public_path__ + "static/media/oraxsoft.5255efce.png";